// images
import blogImg1 from "../img/news/01.jpg";
import blogImg2 from "../img/news/02.jpg";
import blogImg3 from "../img/news/03.jpg";

import blogSingleImg1 from "../img/news/post-1.jpg";
import blogSingleImg2 from "../img/news/post-2.jpg";
import blogSingleImg3 from "../img/news/post-3.jpg";



const blogs = [
    {
        id: '1',
        title: 'Meet Success the Cale Smashing Book By Addy Osmania',
        slug:'How-To-Teach-Kids-Ramadan-Isn’t-About-Food',
        screens: blogImg1,
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2024',
        blogSingleImg:blogSingleImg1, 
        comment:'35',
        day:'28',
        month:'AUGUST',
        blClass:'format-standard-image',
        animation:'1200',
    },
    {
        id: '2',
        title: 'The best business and marketing photos for your',
        slug:'The-Importance-Of-Marriage-In-Islam.',
        screens: blogImg2,
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'David Luis',
        create_at: '23 Sep 2024',
        blogSingleImg:blogSingleImg2, 
        comment:'80',
        day:'25',
        month:'March',
        blClass:'format-standard-image',
        animation:'1400',
    },
    {
        id: '3',
        title: 'How Print-On-DemandimgDrop Shipping Works',
        slug:'Five-Groups-Of-People-During-Ramadan',
        screens: blogImg3,
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Jenefer Willy',
        create_at: '21 Sep 2024',
        blogSingleImg:blogSingleImg3,
        comment:'95',
        day:'23',
        month:'Sep',
        blClass:'format-video',
        animation:'1600',
    }
];
export default blogs;